/**
 * Form success handler for OctoberCMS AJAX forms.
 * Uses jQuery from OctoberCMS globals (window.$).
 */
/* global $ */

export function initForms() {
  window.onFormSuccess = function(form, data, anchor, redirect) {
    if (redirect && redirect.length) {
      const newLocation = redirect.startsWith('http://') || redirect.startsWith('https://')
        ? redirect
        : window.location.origin + redirect;
      window.location.href = newLocation;
      return;
    }

    if (anchor) {
      history.replaceState(null, null, anchor);
    }

    $('body').removeClass('oc-loading');
    $('.stripe-loading-indicator').addClass('loaded');

    setTimeout(() => {
      const $outer = $(form).closest('.form__outer-container');
      const $container = $(form).closest('.form__container');
      const $success = $outer.find('.form__success');

      $outer.height($outer.height());
      $container.fadeOut();
      $outer.delay(100).animate({ height: $success.height() });
      $success.delay(400).fadeIn();
      $container.remove();
    }, 1000);

    window.dispatchEvent(new CustomEvent('onAfterFormSuccess', {
      bubbles: true,
      detail: { form, data, anchor, redirect },
    }));
  };
}
